import { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';
import moment from 'moment/min/moment-with-locales';

//components
import withLocalization from '~/hoc/withLocalization';

//elements
import LoadingSpinner from '~/elements/LoadingSpinner';

//utils
import { minutesToTimeInput } from '../../../utils/timeCalc';

function calcDates() {
    const r = {
        start: moment(new Date()).startOf('week').add(1, 'day'),
        end: moment(new Date()).startOf('week').add(2, 'week'),
        days: [],
    };
    let day = moment(r.start);
    let dayStr = r.start.format('YYYY-MM-DD');
    const toStr = r.end.format('YYYY-MM-DD');
    let i = 0;
    do {
        r.days.push({ date: moment(new Date(day)) });
        dayStr = day.format('YYYY-MM-DD');
        day = day.add(1, 'days');
        i += 1;
    } while (toStr !== dayStr && i < 100);
    return r;
}

class MemberScheduleWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dates: null,
            isLoading: true
        };
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        const { commonStore, dashboardStore, t } = this.props;
        try {
            const dates = calcDates();
            const { shifts: list } = await dashboardStore.getSchedules({
                start: dates.start.format('YYYY-MM-DD'),
                end: dates.end.format('YYYY-MM-DD'),
            });
            dates.days.forEach(day => {
                day.rows = list.filter(r => r.for_date === day.date.format('YYYY-MM-DD'));
            });
            this.setState({ dates, isLoading: false });
        } catch (error) {
            console.error(error);
            commonStore.addNotification(t(error.message || "Something went wrong"), null, 'error');
            this.setState({ isLoading: false });
        }
    }


    renderItem(item) {
        const { t } = this.props;
        if (item.source === 'vacation')
            return <div className="vacation">{t('Vacation')}</div>;

        if (item.source === 'absence')
            return <div className="absence">{t('Absence')}</div>;

        return (
            <div className="shift">
                <div className="timing">
                    {minutesToTimeInput(item.start_time, true)} - {minutesToTimeInput(item.end_time, true)}
                </div>
                <div className="title">
                    {item.project_name} : {item.task_name}
                </div>
            </div>
        );
    }

    renderItems(day) {
        return (
            <Fragment>
                {day.rows.map(item => (
                    <div key={`${item.id}`} className={`schedule__item schedule__item--${item.source}`}>
                        {this.renderItem(item)}
                    </div>
                ))}
            </Fragment>
        );
    }

    renderInner() {
        const { dates } = this.state;
        return (
            <Fragment>
                {dates.days.map(day => (
                    <div
                        key={`${day.date}`}
                        className={`schedule__daywrapper ${day.rows.length > 0 ? 'filled' : ''} ${day.date.day() == 0 ? 'sunday' : ''
                            }`}
                    >
                        <div className="schedule__daytitle">{day.date.format('ddd MMM D')}</div>
                        <div className="schedule__itemswrapper">{this.renderItems(day)}</div>
                    </div>
                ))}
            </Fragment>
        );
    }

    render() {
        const { dates, isLoading } = this.state;
        if (isLoading) <LoadingSpinner />
        return (
            <div>
                {dates && this.renderInner()}
            </div>
        );
    }
}

export default inject('commonStore', 'dashboardStore')(withLocalization(observer(MemberScheduleWidget)));
